import { render, staticRenderFns } from "./CreateCampaignSettings.vue?vue&type=template&id=71b790b8&"
import script from "./CreateCampaignSettings.vue?vue&type=script&lang=js&"
export * from "./CreateCampaignSettings.vue?vue&type=script&lang=js&"
import style0 from "./CreateCampaignSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports